export default "__VITE_ASSET__CbsoKmAj__"